























































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import { institutionServer, integralManagementServer } from '@/api/installServer';
import DetailPage from './unit/detailUnit.vue';

@Component({
  components: {
    CollapseTransition,
    TreeUnit,
    PagingUnit,
    DetailPage,
  },
  mixins: [TableStripe],
})
export default class PatrolStandardCheck extends Vue {
  private showFlag: any = 0;
  row: any = '';

  private visible = false;

  private formData: any = {
    deptId: '', // 部门
    staffName: '', // 人员
  };

  private form: any = {
    num: 0, // 弹框 积分
    describe: '', //弹框 描述
    staffIds: [], // 弹框 人员
    spaceId: '',
  };
  private flagDescribe = true;

  private companyList: any = []; // 存储单位列表数据
  private deptIdOptions: any = []; // 存储部门列表数据
  private multipleSelection: any = []; // 批量操作数据

  formRules: any = {
    describe: [{ required: true, message: '请填写描述内容', trigger: 'blur' }],
    spaceId: [{ required: true, message: '请选择单位', trigger: 'blur' }],
  };

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条

  // table数据
  tableData: any[] = [];

  created() {
    this.getIntegralList();
    this.getDeptList();
  }

  /**
   *  desc 获取部门列表数据
   * */
  private getDeptList() {
    institutionServer
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.deptIdOptions = res.data;
        } else {
          this.$message.warning('网络异常，请稍后重试。');
        }
      })
      .catch((error: any) => {});
  }

  /**
   * @desc 单位列表
   * */
  private getCompanyList() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        if (res.code === '200') {
          this.companyList = res.data;
        } else {
        }
      })
      .catch(() => {});
  }

  private getIntegralList(): void {
    integralManagementServer
      .getIntegralListData({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        deptId: this.formData.deptId ? this.formData.deptId : null,
        staffName: this.formData.staffName ? this.formData.staffName : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getIntegralList();
  }

  /**
   * @desc 详情
   **/
  detailHandle(data: any) {
    this.row = data;
    this.showFlag = 1;
  }

  /**
   * @desc 扣除积分
   **/
  rowOperationPointsHandle(data: any) {
    this.visible = true;
    this.flagDescribe = true;
    this.form.staffIds = [data.staffId];
  }

  handleSubmitDialog() {
    (this.$refs['form'] as any).validate((valid: any) => {
      if (valid) {
        if (this.flagDescribe) {
          this.operationIntegral();
        } else {
          this.clearZeroIntegral();
        }
      } else {
        return false;
      }
    });
  }
  private clearZeroIntegral() {
    integralManagementServer
      .clearZeroIntegral({
        describe: this.form.describe,
        spaceId: this.form.spaceId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.hideDialog();
          this.getIntegralList();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }

  private operationIntegral() {
    integralManagementServer
      .operationIntegral({
        describe: this.form.describe,
        num: this.form.num,
        staffIds: this.form.staffIds,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.hideDialog();
          this.getIntegralList();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }
  /**
   * 关闭窗口
   */
  hideDialog() {
    this.visible = false;
    this.form = {
      num: 0,
      describe: '',
      staffIds: [],
    };
    this.flagDescribe = false;
  }
  /**
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getIntegralList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    // 获取全部数据
    this.getIntegralList();
  }
  /**
   * @desc 全员清空操作
   * */
  allClearHandle() {
    this.flagDescribe = false;
    this.visible = true;
    this.getCompanyList();
  }

  /**
   * @desc 批量操作
   * */
  batchOperationHandle() {
    if (this.multipleSelection.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    this.visible = true;
    this.flagDescribe = true;
    this.form.staffIds = this.multipleSelection.map((item: any) => item.staffId);
  }
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  responseHandle() {
    this.showFlag = 0;
    this.getIntegralList();
  }
}
